import { ActionIcon } from './Icons';
import { actionInfo } from '../../../data';
import { ATSConnectHiringRequestTestIds } from 'data-testids/ATS';
import { IndividualHiringRequestAction, RequiredActionsCTAProps } from '../../../types';
import { TitleCTAContainer } from '../../../styles/actionsStyles';
import { useHistory } from 'react-router';
import auth from 'utils/auth';
import { ConnectHiringRequestAction } from '../../../enums';
import { getIsActionRequired } from '../../../utils';

export const RequiredActionsCTA: React.FC<RequiredActionsCTAProps> = ({
  actions,
  applicationLink,
  candidateId,
  isExpanded,
  onOpenModal,
  requirements,
  roleId,
}) => {
  const history = useHistory();
  const isSuperAdmin = auth.isSuperAdminUser();

  return (
    <TitleCTAContainer
      data-testid={ATSConnectHiringRequestTestIds.EXPANDED_CTA_CONTAINER}
      isexpanded={isExpanded}
    >
      {actionInfo
        .slice(0, isSuperAdmin ? actionInfo.length : actionInfo.length - 1)
        .map((data, index) => {
          const actionKey: IndividualHiringRequestAction = data.tooltipText;
          const actionIsMissing = !actions[actionKey];
          const isRequired = getIsActionRequired(actionKey, requirements);

          const handleClick = () => {
            if (data.tooltipText === ConnectHiringRequestAction.application) {
              if (!actionIsMissing && applicationLink) {
                history.push(applicationLink);
              }

              return;
            }
            onOpenModal({ candidateId, modalType: data.tooltipText, roleId });
          };

          return (
            <ActionIcon
              icon={data.icon}
              isExpanded={isExpanded}
              isMissing={actionIsMissing}
              isRequired={isRequired}
              key={index}
              tooltipText={data.tooltipText}
              onClick={handleClick}
            />
          );
        })}
    </TitleCTAContainer>
  );
};
